import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { COLOR_FONT_POINT, COLOR_BORDER } from '@assets/color';

const ButtonWrapper = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: white;
  width: ${({ width }) => width || '200px'};
  height: ${({ height }) => height || '40px'};
  border: 2px solid ${COLOR_FONT_POINT};
  transition: 0.2s ease-in-out;
  border-radius: ${({ borderRadius }) => borderRadius || '30px'};
  background-color: ${COLOR_FONT_POINT};
  color: white;
  &:hover {
    background-color: white;
    color: ${COLOR_FONT_POINT};
  }
  :disabled {
    background-color: ${COLOR_BORDER};
  }
`;

const Button = ({
  style,
  className,
  children,
  name,
  value,
  onClick,
  width,
  height,
  borderRadius,
  ...props
}) => {
  const handleClick = (e) => {
    onClick && onClick(e);
  };

  return (
    <ButtonWrapper
      onClick={handleClick}
      className={className}
      style={style}
      name={name}
      value={value}
      width={width}
      height={height}
      borderRadius={borderRadius}
      {...props}
    >
      {children}
    </ButtonWrapper>
  );
};

Button.propTypes = {
  style: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  children: PropTypes.node,
  name: PropTypes.string,
  value: PropTypes.string,
  onClick: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  borderRadius: PropTypes.string,
};

export default Button;
